import { type CrmObject, ObjectTypes } from '@playbooks/action-cards-utils/src'
import FieldWithIcon from './FieldWithIcon'
import IconWrapper from './IconWrapper'
import { type FC } from 'react'
import { ContactIcon, LinkAwayIcon, PlusCircleGradientIcon } from '../../../components/ui'
import getCrmObjectName from '../../../utils/getCrmObjectName'
import { getContactFullName } from '../../../utils/mapConnecterWidgetValue'
import { useTranslation } from '../../../contexts/localization/Localization'

const SyncLinkItem: FC<{ data: CrmObject }> = ({ data }) => {
  const { text } = useTranslation()
  const isContact = data.objectType === ObjectTypes.Contact
  const name = isContact ? getContactFullName(data.crmFields) : data.crmFields.Name
  const url = isContact ? data.crmFields.Email : data.url
  const icon = isContact ? <ContactIcon /> : <PlusCircleGradientIcon />
  const type = getCrmObjectName(data.objectType)

  return (
    <FieldWithIcon
      icon={<IconWrapper icon={icon} />}
      data={
        <div className={`dark:text-white`}>
          <div>
            <span className={`font-bold`}>
              {text('sync')} {type}:
            </span>{' '}
            <span>{name}</span>
          </div>
          <div className={``}>
            <i className={`mr-1`}>{text('connectCrmWidgetMatchFound')}:</i>{' '}
            <span>
              {name} - {isContact ? url : ''}
            </span>
            <a
              href={url.startsWith('http') ? url : `mailto:${url}`}
              className={`relative top-0.5 ml-1 inline-block w-14px`}
            >
              <IconWrapper color="#7F7F7F" icon={<LinkAwayIcon />} />
            </a>
          </div>
        </div>
      }
    />
  )
}

export default SyncLinkItem
